import sassConstants from '@/constants/sass'

export default {
  XS: sassConstants.xs,
  SM: sassConstants.sm,
  MD: sassConstants.md,
  LG: sassConstants.lg,
  XL: sassConstants.xl,
}
